export const safeDecodeURIComponent = (str) => {
    if (!str)
        return '';
    try {
        const isEncoded = str !== decodeURIComponent(str);
        return isEncoded ? decodeURIComponent(str) : str;
    }
    catch (e) {
        return str;
    }
};
